export default __webpack_public_path__ + "static/media/Kids&Us.07c33ca6.png";